var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"clickoutside",rawName:"v-clickoutside",value:(_vm.close),expression:"close"}],staticClass:"scope-options top-fade-in",style:(("top: " + _vm.top + "px; left: " + _vm.left + "px;"))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }